import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps, EfTabProps } from '@elem/ui/ef-tab';
import { useMemo, useState } from 'react';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';

type ListType = {
    img: string;
    info: {
        title: string;
        desc?: string;
        icons: {
            icon: string;
            title: string;
            desc: string;
        }[];
    };
};

export default function TheComp() {
    const { locale = 'eu' } = getLocal();
    const IS_UK_SITE = locale === 'uk';

    const { t } = useLang('theProduct.Info');
    const { t: t1 } = useLang('theProduct.Info.item1');
    const { t: t2 } = useLang('theProduct.Info.item2');
    const { t: t3 } = useLang('theProduct.Info.item3');

    const list: (EfTabItemProps & ListType)[] = useMemo(
        () => [
            {
                type: '1',
                title: '286Wh',
                info: {
                    title: t1('title'),
                    icons: [
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139712851/router.png',
                            title: t1('name1'),
                            desc: t1('time1'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713400/drone.png',
                            title: t1('name2'),
                            desc: t1('time2'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139712660/car_frige.png',
                            title: t1('name3'),
                            desc: t1('time3'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713212/ps5.png',
                            title: t1('name4'),
                            desc: t1('time4'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713036/refrigerator.png',
                            title: t1('name5'),
                            desc: t1('time5'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713579/desktop.png',
                            title: t1('name6'),
                            desc: t1('time6'),
                        },
                    ],
                },
                img: IS_UK_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1741155599105/sl_r3p-uk.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1741076001012/info1.png',
            },
            {
                type: '2',
                title: '572Wh',
                info: {
                    title: t2('title'),
                    desc: t2('desc'),
                    icons: [
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139712851/router.png',
                            title: t2('name1'),
                            desc: t2('time1'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713400/drone.png',
                            title: t2('name2'),
                            desc: t2('time2'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139712660/car_frige.png',
                            title: t2('name3'),
                            desc: t2('time3'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713212/ps5.png',
                            title: t2('name4'),
                            desc: t2('time4'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713036/refrigerator.png',
                            title: t2('name5'),
                            desc: t2('time5'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713579/desktop.png',
                            title: t2('name6'),
                            desc: t2('time6'),
                        },
                    ],
                },
                img: IS_UK_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1741155598921/sl_r3m-uk.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1741076001181/info2.png',
            },
            {
                type: '3',
                title: '858Wh',
                info: {
                    title: t3('title'),
                    desc: t3('desc'),
                    icons: [
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139712851/router.png',
                            title: t3('name1'),
                            desc: t3('time1'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713400/drone.png',
                            title: t3('name2'),
                            desc: t3('time2'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139712660/car_frige.png',
                            title: t3('name3'),
                            desc: t3('time3'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713212/ps5.png',
                            title: t3('name4'),
                            desc: t3('time4'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713036/refrigerator.png',
                            title: t3('name5'),
                            desc: t3('time5'),
                        },
                        {
                            icon: 'https://websiteoss.ecoflow.com/upload/image/1741139713579/desktop.png',
                            title: t3('name6'),
                            desc: t3('time6'),
                        },
                    ],
                },
                img: IS_UK_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1741155599283/sl_r3mp-uk.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1741076001362/info3.png',
            },
        ],
        [],
    );
    const [active, setActive] = useState<EfTabProps['activeType']>(list[0].type);
    const curItem = useMemo(() => list.find((item) => item.type === active), [active, list]) ?? list[0];
    const handleActive: EfTabProps['onChange'] = (item) => {
        setActive(item.type);
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <div className="info-container">
                <div className="info-left">
                    <div className="info-left-title">{curItem.info.title}</div>
                    {curItem.info.desc && <div className="info-left-desc">{curItem.info.desc}</div>}
                    <div className="info-left-icons">
                        {curItem.info.icons.map((item, idx) => (
                            <div className="info-left-icon" key={item.title}>
                                <EfImg className="info-left-icon-img" pc={item.icon} />
                                <div className="info-left-icon-title">{item.title}</div>
                                <div className="info-left-icon-desc">{item.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <EfImg className="info-right" pc={curItem.img} />
            </div>
            <EfTab theme="white" items={list} activeType={active} onChange={handleActive} />
        </div>
    );
}
